import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Cait = makeShortcode("Cait");
const Menu = makeShortcode("Menu");
const NoCait = makeShortcode("NoCait");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Therion Notes" mdxType="SEO" />
    <h2 {...{
      "id": "therion-3-character-notes"
    }}>{`Therion 3 Character Notes`}</h2>
    <h3 {...{
      "id": "preface"
    }}>{`Preface`}</h3>
    <p>{`This route is a 3 character route for Therion.`}<br parentName="p"></br>{`
`}{`The route is generally straightforward - Orlick and Gareth are relatively scripted as long as Therion goes before the merchants on the first turn and does not die.`}<br parentName="p"></br>{`
`}{`You have ~16,000 to use on the 3% steal rests in Chapter 4 before needing to reload your save.`}<br parentName="p"></br>{`
`}{`Darius is scripted past T1 - you need to break him before his turn and you will win.`}</p>
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Proceed through the cutscenes.`}</p>
    <p>{`Steal all 4 soulstones `}<strong parentName="p">{`Fire, Ice, Wind, Shadow`}</strong>{` from the merchant on your left.`}</p>
    <p>{`When you end up at Ravus Manor, do the cutscene, then loot the purple chest for `}<strong parentName="p">{`Iron Helm`}</strong>{`.`}</p>
    <p>{`After downstairs scene, before stealing from the man, go to the weapon shop.`}</p>
    <p>{`Buy an `}<strong parentName="p">{`Arcane Knife`}</strong>{`, optimize Therion in equipment menu (equips both Arcane Knife and Iron Helm)`}</p>
    <p>{`Run/Break all encounters as you make your way through Ravus Manor.`}</p>
    <h4 {...{
      "id": "heathcote"
    }}>{`Heathcote`}</h4>
    <p>{`You may need healing sometimes if you have a bad turn order (if you heal, it's probably on T3-T4).`}<br parentName="p"></br>{`
`}{`Other than that, the fight is primarily scripted.`}</p>
    <p>{`T1-T4: Throw all 4 soulstones (They will always be at the bottom of your item menu).`}<br parentName="p"></br>{`
`}{`T5: Wildfire x4`}<br parentName="p"></br>{`
`}{`T6: Wildfire`}<br parentName="p"></br>{`
`}{`T7: Wildfire x4`}</p>
    <p>{`Head over to the Quarrycrest area.`}<br parentName="p"></br>{`
`}{`Save at the save point (you may want to walk a little bit there if you want to be safe), and throw yourself at the encounter.`}</p>
    <p>{`Whether or not you die and reload, or escape, head over to Derelict Mine, get the `}<strong parentName="p">{`Wind L`}</strong>{` and teleport back to Boulderfall.`}</p>
    <p>{`Make your way to Atlasdam, breaking and/or fleeing from encounters on the way.`}<br parentName="p"></br>{`
`}{`If you find a cait, kill it with the Wind L, and press the cait button to see the route, which diverges from the noncait route.`}</p>
    <Cait mdxType="Cait">
      <p>{`Get Scholar shrine (Flee from the encounter if you get it before scholar shrine - good luck!)`}</p>
      <p>{`Once you get to Scholar Shrine:`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "jobs"
        }}>{`Jobs`}</h5>
        <p>{`Therion: HP Thief, `}<strong parentName="p">{`Scholar`}</strong>{`, Blizzard + Lightning Blast`}</p>
        <h5 {...{
          "id": "skills"
        }}>{`Skills`}</h5>
        <p>{`Therion: Evasive Manuevers`}</p>
      </Menu>
      <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`, start Therion 2 and immediately leave.`}</p>
      <p>{`Get the `}<strong parentName="p">{`Light M`}</strong>{` on the way to the Wispermill area.`}</p>
      <p>{`Head over to `}<strong parentName="p">{`Forest of Purgation`}</strong>{` and get the `}<strong parentName="p">{`Light L, Forbidden Dagger, and $20000.`}</strong></p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "equipment"
        }}>{`Equipment`}</h5>
        <p>{`Therion: Forbidden Dagger`}</p>
      </Menu>
      <h3 {...{
        "id": "cyrus-ch-1"
      }}>{`Cyrus Ch. 1`}</h3>
      <p>{`Teleport back to Noblecourt, and head over to Atlasdam to recurit Cyrus.`}</p>
      <h4 {...{
        "id": "russell"
      }}>{`Russell`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Light M`}</li>
        <li parentName="ul">{`Therion: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: HP Thief x3`}</li>
      </ul>
      <p>{`Scrutinize the `}<strong parentName="p">{`Light M`}</strong>{` from the little girl, and run to Rippletide.`}</p>
    </Cait>
    <NoCait mdxType="NoCait">
      <h3 {...{
        "id": "cyrus-ch-1-1"
      }}>{`Cyrus Ch. 1`}</h3>
      <p>{`Once in Atlasdam, recruit Cyrus and head into the Subterranean Study.`}<br parentName="p"></br>{`
`}{`Kill 1-2 encounters on the way to Russell, breaking them with either Cyrus Staff or Therion Sword, and use Therion's Wildfire x3.`}</p>
      <h4 {...{
        "id": "russell-1"
      }}>{`Russell`}</h4>
      <p>{`Kill Russell with the Wind L.`}</p>
      <p>{`Scrutinize the `}<strong parentName="p">{`Light M`}</strong>{` from the little girl, and leave.`}<br parentName="p"></br>{`
`}{`Once you have enough JP:`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "skills-1"
        }}>{`Skills`}</h5>
        <ul>
          <li parentName="ul">{`Therion: HP Thief`}</li>
          <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
        </ul>
      </Menu>
      <p>{`Grind encounters on the way to Whistlewood, kill the Whistlewood encounter with the Light M, and kill encounters as needed until Cyrus has 100 JP.`}</p>
      <p>{`Teach Cyrus `}<strong parentName="p">{`Blizzard`}</strong>{`, and give him `}<strong parentName="p">{`Evasive Manuevers`}</strong>{`.`}</p>
      <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`, start Therion 2 and immediately leave.`}</p>
      <p>{`Get the `}<strong parentName="p">{`Light M`}</strong>{` on the way to the Wispermill area.`}</p>
      <p>{`Head over to `}<strong parentName="p">{`Forest of Purgation`}</strong>{` and get the `}<strong parentName="p">{`Light L, Forbidden Dagger, and $20000.`}</strong></p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "equipment-1"
        }}>{`Equipment`}</h5>
        <p>{`Therion: Forbidden Dagger`}</p>
      </Menu>
      <p>{`Teleport to Atlasdam and head to Rippletide to recruit Tressa.`}</p>
    </NoCait>
    <h3 {...{
      "id": "tressa-ch-1"
    }}>{`Tressa Ch. 1`}</h3>
    <p>{`Kill the encounter using `}<Cait mdxType="Cait">{`Therion Lightning Blast x2.`}</Cait><NoCait mdxType="NoCait">{`either an M stone or Cyrus's Lightning Blast x2.`}</NoCait></p>
    <h4 {...{
      "id": "mikk-and-makk"
    }}>{`Mikk and Makk`}</h4>
    <p>{`Light L + Light M`}<NoCait mdxType="NoCait">{`OR Therion HP Thief Makk & Cyrus Lightning Blast x2`}</NoCait></p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head over to Stonegard area, while getting the `}<strong parentName="p">{`$1200`}</strong>{` chest on the way.`}</p>
    <p>{`Get the `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head over to Moonstruck Coast, S+Q there, and get the `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}<NoCait mdxType="NoCait">{`Armor Corrosive, `}</NoCait>{` `}<strong parentName="li">{`Warrior`}</strong>{` + Incite`}</li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Merchant`}</strong>{` + Hired Help`}</li>
        <li parentName="ul">{`Tressa: Hired Help`}<Cait mdxType="Cait">{`, `}<strong parentName="li">{`Scholar`}</strong></Cait></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-pt2"
    }}>{`Therion Ch.2 Pt.2`}</h3>
    <p>{`Optionally, Scrutinize the lady at the entrance for Thunder L. If you lose reputation, restore it at the Tavern after the cutscene.`}</p>
    <ul>
      <li parentName="ul">{`If you are close to losing reputation after getting the Scrutinize, you can consider going for Thieving Tips & Tricks and Curious Antique`}<br parentName="li"></br>
        {`Scrutinizes now so you can restore reputation along the way. `}</li>
    </ul>
    <p>{`Continue the story, up until you go to the Tavern. If you need to, restore reputation.`}<br parentName="p"></br>{`
`}{`If you didn't get the Thunder L, TP `}<strong parentName="p">{`Rippletide`}</strong>{` and Scrutinize Tony's Mom for one.`}</p>
    <p>{`After the Tavern cutscene, TP `}<strong parentName="p">{`Bolderfall`}</strong>{` and head over to the Northreach area.`}<br parentName="p"></br>{`
`}{`At the Northreach area, head into Maw of the Ice Dragon, loot the `}<strong parentName="p">{`$30000`}</strong>{` chest and head out.`}</p>
    <p>{`You'll get 2x Lizards on the way to Northreach.`}<br parentName="p"></br>{`
`}{`Break them with HHB x2, then use a Thunder L to kill.`}<br parentName="p"></br>{`
`}{`Use Therion's Incite if he is first as needed.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Sometimes you win this battle with people dead at the end. You might need to make some adjustments.`}<br parentName="p"></br>{`
`}{`Therion: Nourishing S + Iron Helm lets him survive Darius. GL with Ch.3 8%s :)`}<br parentName="p"></br>{`
`}{`Cyrus: With Cait route no Blizzard for Orlick?`}<br parentName="p"></br>{`
`}{`Tressa: Needs Nourish S + Defend to survive crit.`}</p>
    </blockquote>
    <p>{`Enter Northreach, TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch-2-pt3"
    }}>{`Therion Ch. 2 Pt.3`}</h3>
    <ul>
      <li parentName="ul">{`Scrutinize Green Merchant man for `}<strong parentName="li">{`Thieving Tips + Tricks`}</strong></li>
      <li parentName="ul">{`Purchase `}<strong parentName="li">{`Empowering Bracelet`}</strong></li>
      <li parentName="ul">{`Scrutinize the blue merchant for `}<strong parentName="li">{`Curious Antique`}</strong></li>
      <li parentName="ul">{`Steal `}<strong parentName="li">{`Empowering Ring`}</strong>{` from guy guarding house.`}</li>
      <li parentName="ul">{`Pick `}<strong parentName="li">{`Curious Antique`}</strong>{`.`}</li>
      <li parentName="ul">{`Steal `}<strong parentName="li">{`3 M Stones`}</strong>{` in Tavern.`}</li>
    </ul>
    <p>{`Continue the story until you do the 2nd Steal (Wyvern Scale).`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <p>{`Head over to the Wellspring area to tag Wellspring, then head to the Marsalim area.`}</p>
    <p>{`In the Marsalim area, grab `}<strong parentName="p">{`20k + Thunder L`}</strong>{`, and head inside Marsalim Catacombs.`}</p>
    <p>{`Get the `}<strong parentName="p">{`Viper Dagger`}</strong>{` inside Marsalim Catacombs and exit out.`}</p>
    <p>{`Head to Marsalim.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`2x Pom L`}</strong>{` from the man near the equipment shop to the right.`}<br parentName="p"></br>{`
`}{`Head to the palace, get the `}<strong parentName="p">{`Tempest Amulet`}</strong>{`, and buy all `}<strong parentName="p">{`3 Soulstone L`}</strong>{` from the guard on the right.`}<br parentName="p"></br>{`
`}{`Head to the room to the right side and grab the `}<strong parentName="p">{`Enchanted Circlet, High Horse Armor, and $25000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch3-finale"
    }}>{`Therion Ch.3 Finale`}</h3>
    <p>{`Finish story stuff.`}<br parentName="p"></br>{`
`}{`You can choose to S+Q in the second screen or try to make it through without an encounter.`}</p>
    <p>{`You can do this menu anytime before Orlick.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Viper Dagger, Optimize, Empowering Ring + Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}<Cait mdxType="Cait"><strong parentName="li">{`Armor Corrosive`}</strong></Cait><NoCait mdxType="NoCait">{`Thousand Spears`}</NoCait></li>
        <li parentName="ul">{`Cyrus: `}<Cait mdxType="Cait">{`Blizzard, `}</Cait>{`Sidestep`}</li>
        <li parentName="ul"><Cait mdxType="Cait">Tressa: Blizzard</Cait></li>
      </ul>
      <p>{`Heal Therion to full.`}</p>
    </Menu>
    <h4 {...{
      "id": "orlick"
    }}>{`Orlick`}</h4>
    <NoCait mdxType="NoCait">
      <p>{`There is a chance Therion or someone can die on T3 if you get unlucky with Magic Missile. If so, olive the dead person and repeat T3/T4 (breaking Orlick) as needed.`}</p>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Incite`}</li>
        <li parentName="ul">{`Cyrus: Blizzard`}</li>
        <li parentName="ul">{`Tressa: HHM x2 `}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: AC x2`}</li>
        <li parentName="ul">{`Tressa: Shadow L`}</li>
        <li parentName="ul">{`Cyrus: Thunder L`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Thousand Spears (If you get many hits and Cyrus is last, Tressa can break on her next action and turn it into a 3T fight)`}</li>
        <li parentName="ul">{`Tressa: Attacks to break / Defend`}</li>
        <li parentName="ul">{`Cyrus: Spear x4 Orlick OR HHV x4 if broken`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Tressa/Cyrus: HHV x3`}</li>
      </ul>
    </NoCait>
    <Cait mdxType="Cait">
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Incite`}</li>
        <li parentName="ul">{`Cyrus: Blizzard`}</li>
        <li parentName="ul">{`Tressa: Blizzard`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: AC`}</li>
        <li parentName="ul">{`Tressa: Soulstone L (except Wind)`}</li>
        <li parentName="ul">{`Cyrus: Soulstone L (except Wind)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Attack x4`}</li>
        <li parentName="ul">{`Merchant 1: Spear x3`}</li>
        <li parentName="ul">{`Merchant 2: HHV x4`}</li>
      </ul>
    </Cait>
    <h3 {...{
      "id": "chapter-3"
    }}>{`Chapter 3`}</h3>
    <p>{`Proceed through the story and do the steals.`}<br parentName="p"></br>{`
`}{`When you steal from the tavern person, you'll have infinite tries.`}</p>
    <p>{`For the encounter before Gareth, kill them using Light M + HHB or Light S.`}</p>
    <p>{`Heal Therion as needed, and begin the fight with Gareth.`}</p>
    <h4 {...{
      "id": "gareth"
    }}>{`Gareth`}</h4>
    <p>{`This fight is scripted, except if Therion dies to crit slices (not posssible with a cait), or if Therion is not first and his adds kill someone before Therion can use Incite.`}</p>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Incite`}</li>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHV x3`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
    </ul>
    <p>{`If Therion dies before his action on T2, you'll need Cyrus to Olive and hope Therion is before him.`}<br parentName="p"></br>{`
`}{`If not, you'll need to throw a Soulstone M to make up the damage.`}<br parentName="p"></br>{`
`}{`If he revives after Cyrus, you'll need to throw 2 L Stones to make up the damage. It's also a range, might need a bit more.`}</p>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: HHV x4`}</li>
      <li parentName="ul">{`Therion: HP Thief x4`}</li>
    </ul>
    <h3 {...{
      "id": "chapter-4"
    }}>{`Chapter 4`}</h3>
    <p>{`After the cutscene, get `}<strong parentName="p">{`Master's Longbow`}</strong>{`. Heal Therion if needed before the forced encounter.`}</p>
    <p>{`Kill the forced encounter here.`}<br parentName="p"></br>{`
`}{`Use Therion's Incite if he is first, and have both merchants use HHM x2 to break.`}<br parentName="p"></br>{`
`}{`Use 1L 1M or 3M to kill the encounter.`}</p>
    <p>{`Proceed through the cutscenes.`}<br parentName="p"></br>{`
`}{`Before attempting the 3%, head to the NPC near the provisioner shop.`}</p>
    <p>{`Steal the `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{`, Scrutinize him (you'll pick it up later at the tavern), and purchase the `}<strong parentName="p">{`Curious Antique`}</strong>{`.`}</p>
    <p>{`Afterwards, trigger the 3% cutscene and do the steal.`}<br parentName="p"></br>{`
`}{`Each reputation restore costs 1k, and assuming you did no reputation resets, you'll have roughly 15k worth of resets you can do before having to reload.`}<br parentName="p"></br>{`
`}{`Good luck!`}</p>
    <p>{`Afterwards, perform the following menu:`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <p>{`Therion: Unequip (If you got 3% within 5-10 tries, you can keep Viper Dagger on him), Empowering Ring (SKIP THIS if Therion has cait XP at any point)`}<br parentName="p"></br>{`
`}{`Tressa: Gareth's Helm, Empowering Bracelet (If she has Cait XP, give her an Empowering Ring instead)`}</p>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <p>{`Cyrus: Warrior + 2 Skills, back to Merchant`}<br parentName="p"></br>{`
`}{`Therion: Shackle Foe, Warrior (+ Thousand Spears if needed)`}</p>
      <h5 {...{
        "id": "support-skills"
      }}>{`Support Skills`}</h5>
      <p>{`Cyrus: Cover`}<br parentName="p"></br>{`
`}{`Therion: Fleetfoot`}</p>
    </Menu>
    <p>{`At the equipment shop, sell all items for ~$88,300.`}</p>
    <p>{`Heal everyone to full, proceed through the dungeon (Get the Ice M chest before entering the Cathedral if you don't have any M stones), and save before Darius.`}</p>
    <h4 {...{
      "id": "darius"
    }}>{`Darius`}</h4>
    <p>{`You need to break him before he gets his action.`}<br parentName="p"></br>{`
`}{`Afterwards, the fight is scripted (unless you have the second scenario below and you're not on Cait Route).`}</p>
    <p>{`This fight either needs 1L (used when broken), or 1L 1M (if the Wind L is used to to help break Darius)`}</p>
    <h4 {...{
      "id": "standard-fight-therion-or-therion--any-merchant-before-darius"
    }}>{`Standard Fight (Therion or Therion + any merchant before Darius)`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Thousand Spears`}</li>
      <li parentName="ul">{`Tressa: Pom L Cyrus or Wind L or Spear (if before Darius)`}</li>
      <li parentName="ul">{`Cyrus: Pom L Self or wind L or Spear (if before Darius)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Cyrus: Sidestep x3`}</li>
      <li parentName="ul">{`Therion: Shackle Foe`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      <li parentName="ul">{`Cyrus: Collect x4`}</li>
      <li parentName="ul">{`Tressa: Tradewinds`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Cyrus: Pom L Self`}</li>
      <li parentName="ul">{`Tressa: Tradewinds`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Dagger x4`}</li>
      <li parentName="ul">{`Cyrus + Tressa: HHV x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Soulstone L or M if needed`}</li>
      <li parentName="ul">{`Cyrus + Tressa: HHV x3`}</li>
    </ul>
    <h4 {...{
      "id": "2-merchants-before-darius-fight"
    }}>{`2 Merchants before Darius Fight`}</h4>
    <p><strong parentName="p">{`Requires a Pom M if noncait, and you risk Tressa dying to crit.`}</strong></p>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Pom L Cyrus`}</li>
      <li parentName="ul">{`Tressa: `}<NoCait mdxType="NoCait">{`Spear x2`}</NoCait><Cait mdxType="Cait">{`Blizzard`}</Cait></li>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: `}<Cait mdxType="Cait">{`Defend`}</Cait><NoCait mdxType="NoCait">{`Pom M Self`}</NoCait></li>
      <li parentName="ul">{`Cyrus: Sidestep x3`}</li>
      <li parentName="ul">{`Therion: Shackle Foe`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      <li parentName="ul">{`Cyrus: Collect x4`}</li>
      <li parentName="ul">{`Tressa: Tradewinds`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Cyrus: Pom L Self`}</li>
      <li parentName="ul">{`Tressa: Tradewinds`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Dagger x4`}</li>
      <li parentName="ul">{`Cyrus + Tressa: HHV x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6-1"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Soulstone L or M if needed`}</li>
      <li parentName="ul">{`Cyrus + Tressa: HHV x3`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      